import React from "react";
import "./style.scss";
import Icon from "../../elements/icon";
import Link from "../../elements/link";
import { Heading } from "../../elements";
import Edit from "../../svg-icons/edit";
import { useSelector } from "react-redux";
import { pdpDeliverySelector, pdpTouchPointSelector } from "../../selectors/pdp";
import useQuery from "../../utils/useQuery";
import { appendQuery } from "../../utils/urlHelper";

const DeliveryDetailsAccordion = ({ fields, details, deliveryLabel }) => {
  const query = useQuery();
  /*Redux start*/
  const pdpDelivery = useSelector(pdpDeliverySelector);
  const pdpTouchPoint = useSelector(pdpTouchPointSelector);
  /*Redux end*/
  const { deliveryEditLink, deliveryAddressTitle, deliveryMethodTitle } = fields;
  const link = deliveryEditLink && {
    ...deliveryEditLink.value,
    url: appendQuery(deliveryEditLink?.value?.href, query)
  };
  return (
    <div className="delivery-details">
      {details && details.length > 0 ? (
        <>
          <div className="delivery-content-header">
            <div className="header">{deliveryAddressTitle?.value}</div>
            <div className="icon">
              {link && (
                <Link {...link}>
                  <Icon name="Edit" className="edit-icon" colorScheme="outline-green" />
                </Link>
              )}
            </div>
          </div>
          <div className="delivery-address">
            {(details || []).map((row, index) => (
              <div className="location-name" key={row+index}>
                {row}
              </div>
            ))}
          </div>
          <div className="delivery-content-header">
            <div className="header">{deliveryMethodTitle?.value}</div>
            <div className="icon">
              {link && (
                <Link {...link}>
                  <Icon name="Edit" className="edit-icon" colorScheme="outline-green" />
                </Link>
              )}
            </div>
          </div>
          <div className="delivery-method-name">{pdpDelivery?.label || deliveryLabel}</div>
        </>
      ) : (
        <>
          <div className="delivery-content-header">
            <div className="header">{pdpDelivery?.label || deliveryLabel}</div>
            <div className="icon">
              {link && (
                <Link {...link}>
                  <Icon name="Edit" className="edit-icon" colorScheme="outline-green" />
                </Link>
              )}
            </div>
          </div>
          <div className="delivery-address">
            <div>{pdpTouchPoint?.name}</div>
            <div>{pdpTouchPoint?.address}</div>
            <div>
              {pdpTouchPoint?.zipCode} {pdpTouchPoint?.city}
            </div>
            <div>{pdpTouchPoint?.country}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryDetailsAccordion;
